import { render } from "./ProcessedDocumentStatuses.vue?vue&type=template&id=deee067a&scoped=true"
import script from "./ProcessedDocumentStatuses.vue?vue&type=script&lang=js"
export * from "./ProcessedDocumentStatuses.vue?vue&type=script&lang=js"

import "./ProcessedDocumentStatuses.vue?vue&type=style&index=0&id=deee067a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deee067a"]])

export default __exports__